import { useQuery } from '@tanstack/react-query'
import {
  getStudyHomepageStudiesHomepageGet,
  GetStudyHomepageStudiesHomepageGetData,
  Pagination,
} from '@common/config/api/client'

export const useStudiesHomepage = (queryKey: string[], params: GetStudyHomepageStudiesHomepageGetData['query']) => {
  const stableQueryKey = [
    ...queryKey,
    params.limit,
    params.next_cursor,
    params.previous_cursor,
    params.order_by,
    params.search || '',
  ]

  const { data, isLoading, isError, error } = useQuery({
    queryKey: stableQueryKey,
    queryFn: () => {
      return getStudyHomepageStudiesHomepageGet({
        query: {
          limit: params.limit,
          next_cursor: params.next_cursor,
          previous_cursor: params.previous_cursor,
          order_by: params.order_by,
          search: params.search || undefined,
        },
      })
    },
    select: ({ data }) => {
      return {
        studies: data?.items,
        pagination: data?.pagination,
      }
    },
  })

  const { studies = [] } = data || {}
  const { pagination = {} as Pagination } = data || {}

  return {
    studies,
    pagination,
    isLoading,
    isError,
    error,
  }
}
